<router-outlet></router-outlet>
<app-alert *ngIf="(alert | async)?.show" [alert]="alert | async"></app-alert>